module.exports = __webpack_public_path__ + "static/img/iphone_msptitle2.5c58d7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_msptitle2.png
// module id = yer/
// module chunks = 0